<template>
  <div class="row">
    <div class="col-md-3">
      <b-form-group label="Litros">
        <b-form-input
          data-cy="liters"
          data-vv-as="litros"
          name="liters"
          v-model="chargeGasolineForm.liters"
          type="number"
          :state="errors.has('custom-document-part-5.liters') ? false : null"
          v-validate="'required'"
          :formatter="maxLength"
        />
        <div
          v-if="errors.has('custom-document-part-5.liters')"
          class="con-text-validation span-text-validation-danger v-enter-to text-left"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-5.liters') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-3">
      <b-form-group label="Vale/Factura">
        <b-form-input
          data-cy="invoice"
          data-vv-as="vale/factura"
          name="invoice"
          v-model="chargeGasolineForm.invoice"
          type="text"
          :state="errors.has('custom-document-part-5.invoice') ? false : null"
          v-validate="'required'"
          maxLength="15"
        />
        <div
          v-if="errors.has('custom-document-part-5.invoice')"
          class="con-text-validation span-text-validation-danger v-enter-to text-left"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-5.invoice') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-3">
      <InputCurrency
        v-model="chargeGasolineForm.amount"
        id="amount"
        name="amount"
        data-cy="amount"
        v-validate="'required|min:1'"
        :state="errors.has('custom-document-part-5.amount') ? false : null"
        :danger="errors.has('custom-document-part-5.amount')"
        :danger-text="errors.first('custom-document-part-5.amount')"
        data-vv-as="monto"
      />
    </div>
    <div class="col-md-3">
      <b-form-group label="KM Carga">
        <b-input-group append="KM">
          <b-form-input
            data-cy="kilometer-charge"
            data-vv-as="KM carga"
            name="kilometerCharge"
            v-model="chargeGasolineForm.kilometerCharge"
            type="number"
            :state="errors.has('custom-document-part-5.kilometerCharge') ? false : null"
            v-validate="'required'"
            :formatter="maxLength"
          />
        </b-input-group>
        <div
          v-if="errors.has('custom-document-part-5.kilometerCharge')"
          class="con-text-validation span-text-validation-danger v-enter-to text-left"
        >
          <span class="span-text-validation">
            {{ errors.first('custom-document-part-5.kilometerCharge') }}
          </span>
        </div>
      </b-form-group>
    </div>
    <div class="col-md-12">
      <div class="row align-items-center mt-3">
        <div class="col-md-12">
          <label>Adjuntar Voucher Combustible</label>
        </div>
        <div class="col-md-3 align-items-end">
          <upload-file
            permission="*"
            accept="application/pdf, .jpeg, .jpg, .png"
            v-model="chargeGasolineForm.voucher"
            text="Seleccionar documento"
            upload-to="ed"
            :button-class="{
              'btn-block': true, 'mb-5': errors.has('custom-document-part-5.fileName')
            }"
            container-class="w-100"
            @input="addFile()"
          />
        </div>
        <div
          class="col-md-9"
          v-if="chargeGasolineForm.voucher && Object.keys(chargeGasolineForm.voucher).length"
        >
          <div class="d-flex flex-row align-items-center">
            <vs-icon
              icon="description"
              size="45px"
              color="primary"
            />
            <b class="text-truncate w-100">{{ chargeGasolineForm.voucher.name }}</b>
          </div>
        </div>
        <div class="col-md-12">
          <div
            v-if="!!error.message"
            class="con-text-validation span-text-validation-danger
                vs-input--text-validation-span v-enter-to text-left"
          >
            <span class="span-text-validation">
              {{ error.message }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <b-button
        data-cy="add-charge-button"
        variant="primary"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        @click="addCharge()"
      >
        Agregar Carga
      </b-button>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import InputCurrency from '@/components/InputCurrency';

export default {
  directives: {
    Ripple
  },
  components: {
    InputCurrency,
    UploadFile
  },
  data() {
    return {
      clearInputAmount: false,
      chargeGasolineForm: {
        liters: '',
        invoice: '',
        amount: 0,
        kilometerCharge: '',
        voucher: {}
      },
      error: {
        message: ''
      }
    };
  },
  methods: {
    maxLength(value) {
      return String(value).substring(0, 15);
    },
    async addFile() {
      this.error.message = '';
      if (this.chargeGasolineForm.voucher.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        this.chargeGasolineForm.file = {};
      }
      await this.$validator.reset();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addCharge() {
      const isValid = await this.validateForm('custom-document-part-5');
      if (!isValid) {
        return;
      }
      if (!this.chargeGasolineForm.voucher.name) {
        this.error.message = 'Debe agregar el documento para adjuntar la carga de combustible';
        return;
      }
      if (this.chargeGasolineForm.liters && !this.chargeGasolineForm.amount) {
        this.error.message = 'Debes agregar un valor válido para el monto';
        return;
      }

      const row = {
        liters: this.chargeGasolineForm.liters,
        invoice: this.chargeGasolineForm.invoice,
        amount: this.chargeGasolineForm.amount,
        kilometerCharge: this.chargeGasolineForm.kilometerCharge,
        voucher: this.chargeGasolineForm.voucher
      };

      this.$emit('add-charge-gasoline', row);

      this.chargeGasolineForm.liters = '';
      this.chargeGasolineForm.invoice = '';
      this.chargeGasolineForm.amount = '';
      this.error.message = '';
      this.chargeGasolineForm.amount = 0;
      this.chargeGasolineForm.kilometerCharge = '';
      this.clearInputAmount = true;
      this.chargeGasolineForm.voucher = {};

      await this.$validator.reset();
    }
  }
};
</script>
